var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import translate from '../../../lib/utils/translate';

var Adapter = function Adapter(BaseComponent) {
  var InputAdapter = function InputAdapter(_ref, _ref2) {
    var name = _ref.name,
        others = _objectWithoutProperties(_ref, ['name']);

    var intl = _ref2.intl;

    return React.createElement(Field, {
      name: name,
      render: function render(_ref3) {
        var input = _ref3.input,
            meta = _ref3.meta;

        return React.createElement(BaseComponent, _extends({}, input, others, {
          errortext: meta.touched && meta.error ? translate({ id: meta.error }, intl) : null
        }));
      }
    });
  };

  InputAdapter.contextTypes = {
    intl: PropTypes.object
  };

  return InputAdapter;
};

export default Adapter;